<template>
    <div class="c-loading__indicator">
        <div class="c-loading__bar"></div>
    </div>
</template>
  